// Detect if we're running locally vs. on a deployed domain
const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

// In production the API is served same-origin (Nginx proxies /api to the backend),
// so we don't hardcode the host — works for any domain (app.ovatik.com, fleet.ovatik.com, …).
const API_BASE_URL = isProduction
  ? `${window.location.protocol}//${window.location.hostname}`  // same-origin, same protocol
  : (process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000');

export default API_BASE_URL;



